<template>
  <b-modal
    id="pending-documentation-modal"
    v-model="isVisible"
    centered
    :hide-header-close="isBlocking"
    :no-close-on-backdrop="isBlocking"
    :no-close-on-esc="isBlocking"
    @hide="onHide"
  >
    <template #modal-title>
      <span class="pending-doc-title">{{ title }}</span>
    </template>

    <p class="pending-doc-body mb-0">
      {{ body }}
    </p>

    <template #modal-footer>
      <b-button
        v-if="!isSignatureStage"
        variant="outline-primary"
        @click="goToCompanyInfo"
      >
        Ir para meu cadastro
      </b-button>
      <b-button
        v-if="ctaUrl"
        variant="primary"
        @click="openCta"
      >
        Verificar documentos
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BModal, BButton } from 'bootstrap-vue'
import * as types from '@/modules/account/store/types'
import { REPORT_HUB_ROUTE, REPORT_ROUTE } from '@/constants/appointment_report_v2'

const COMPANY_INFO_ROUTE = 'consultant-company-info-save'
const SIGNATURE_STAGE = 'signature'
// `trigger` do evento `hide` do BModal quando quem fecha é o PN (X do cabeçalho, Esc, clique no fundo).
const USER_HIDE_TRIGGERS = ['headerclose', 'esc', 'backdrop']

// O report obrigatório e a tela de cadastro têm precedência sobre o aviso: um aviso bloqueante (sem
// fechar) por cima do report impediria o PN de sair da trava. Com a trava ativa ele nunca aparece.
const BLOCKING_FLOW_ROUTES = [
  COMPANY_INFO_ROUTE,
  'contract-save',
  REPORT_HUB_ROUTE,
  REPORT_ROUTE,
]

const COPY = {
  documents: {
    title: '⚠️ Documentação Pendente',
    body: 'Identificamos documentos pendentes em seu cadastro. A regularização é obrigatória '
      + 'para manter seu acesso ativo. Caso a pendência não seja resolvida dentro do prazo, '
      + 'seu acesso poderá ser bloqueado.',
  },
  signature: {
    title: '⚠️ Assinatura Pendente',
    body: 'Seu contrato já foi enviado para assinatura por e-mail e ainda não foi assinado. '
      + 'A assinatura é obrigatória para manter seu acesso ativo. Caso a pendência não seja '
      + 'resolvida dentro do prazo, seu acesso poderá ser bloqueado.',
  },
}

export default {
  name: 'PendingDocumentationModal',
  components: { BModal, BButton },
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      user: types.USER,
      onboardingStatus: types.PN_ONBOARDING_STATUS,
      isReportLocked: types.IS_REPORT_LOCKED,
    }),
    alert() {
      return this.onboardingStatus ? this.onboardingStatus.document_alert : null
    },
    isBlocking() {
      return !!(this.alert && this.alert.blocking)
    },
    ctaUrl() {
      return this.alert ? this.alert.cta_url : null
    },
    isSignatureStage() {
      return !!(this.alert && this.alert.stage === SIGNATURE_STAGE)
    },
    copy() {
      return this.isSignatureStage ? COPY.signature : COPY.documents
    },
    title() {
      return this.copy.title
    },
    body() {
      return this.copy.body
    },
    shouldShow() {
      return !!this.alert
        && !this.isReportLocked
        && !BLOCKING_FLOW_ROUTES.includes(this.$route.name)
    },
  },
  watch: {
    shouldShow: {
      immediate: true,
      handler(val) {
        this.isVisible = val
      },
    },
  },
  methods: {
    ...mapActions({ dismissAlert: types.DISMISS_PN_DOCUMENT_ALERT }),

    // Só o fechamento feito pelo PN (X, Esc, fundo) dispensa o aviso do dia. O `hide` programático — `shouldShow`
    // virou false porque a trava de report chegou ou a rota mudou — tem `trigger` null: o aviso volta depois.
    onHide(bvEvent) {
      if (!bvEvent || !USER_HIDE_TRIGGERS.includes(bvEvent.trigger)) return
      this.dismissIfNonBlocking()
    },
    dismissIfNonBlocking() {
      if (this.alert && !this.alert.blocking) {
        this.dismissAlert(this.alert.day)
      }
    },
    openCta() {
      if (this.ctaUrl) {
        window.open(this.ctaUrl, '_blank', 'noopener')
      }
    },
    goToCompanyInfo() {
      if (this.user && this.user.appify_consultant_id) {
        // O PN foi resolver: dispensa o aviso do dia (o `hide` da troca de rota é programático e não dispensa).
        this.dismissIfNonBlocking()
        this.$router.push({
          name: COMPANY_INFO_ROUTE,
          params: { id: this.user.appify_consultant_id },
        }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pending-doc-title {
  font-weight: 600;
}

.pending-doc-body {
  font-size: 0.95rem;
  line-height: 1.55;
}
</style>
